<template>
  <div class="rt-tool-tip" v-on-clickaway="close">
    <span
      class="rt-tool-tip__icon +text-center"
      v-if="showIcon"
      @click.stop="toggleTooltip"
      >i</span
    >
    <small v-if="useSmall">
      <a
        v-if="!showIcon"
        :class="linkClass"
        class="rt-tool-tip__row-copy --link --small"
        @click.prevent="toggleTooltip"
      >
        {{ linkText }}
      </a>
    </small>
    <template v-else>
      <a
        v-if="!showIcon"
        :class="linkClass"
        class="rt-tool-tip__row-copy --link --medium"
        @click.prevent="toggleTooltip"
      >
        {{ linkText }}
      </a>
    </template>
    <div
      :class="`rt-tool-tip__box --${arrowHorizontalPosition}`"
      v-show="shownTooltip"
    >
      <div class="rt-tool-tip__arrow"></div>
      <div class="rt-tool-tip__copy">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

//////////////////////////////////////////////////////////////////////////////
//////// @DEPRECATED - Rewrite or clean up for any future use ////////////////
//////////////////////////////////////////////////////////////////////////////

export default {
  props: {
    arrowHorizontalPosition: {
      type: String,
      default: 'pos-right'
    },
    linkText: {
      type: String,
      default: ''
    },
    useSmall: {
      type: Boolean,
      default: true
    },
    linkClass: String
  },

  data() {
    return {
      shownTooltip: false,
      showIcon: !this.linkText.length
    }
  },

  methods: {
    toggleTooltip() {
      this.shownTooltip = !this.shownTooltip
    },
    close() {
      this.shownTooltip = false
    }
  },

  mixins: [clickaway]
}
</script>
